<template>
  <div class="panel panel-primary">
    <div class="panel-heading">
      <h3 class="panel-title">Telephone</h3>
    </div>
    <div class="panel-body">
      01706 750 293
    </div>
  </div>
</template>
<script>
export default {
  name: 'telephone-box'
}
</script>